import { ImageOff } from 'lucide-react';
import Photo from '../ui/Photo';
import { uploadUrl } from '../../lib/uploads';

const MAX_THUMBS = 4;

/**
 * Hero image plus a thumbnail grid. Hosts upload anywhere from one photo to a
 * dozen, so the layout has to fill cleanly at every count — an odd number of
 * thumbnails stretches the last one across both columns rather than leaving a
 * hole in the corner.
 */
export default function PhotoGallery({ photos = [], title }) {
  if (photos.length === 0) {
    return (
      <div className="grid h-72 place-items-center rounded-xl bg-slate-200 text-slate-400">
        <ImageOff className="h-8 w-8" aria-hidden="true" />
      </div>
    );
  }

  const [hero, ...others] = photos;
  const thumbs = others.slice(0, MAX_THUMBS);
  const extraCount = photos.length - 1 - thumbs.length;

  return (
    <div className="grid h-72 gap-2 sm:h-96 sm:grid-cols-2">
      <Photo src={uploadUrl(hero)} alt={title} className="h-full w-full rounded-xl object-cover" />

      {thumbs.length > 0 && (
        // auto-rows-fr is load-bearing: without it the nested rows size to
        // content, the h-full children collapse to zero, and the column vanishes.
        <div className="hidden h-full auto-rows-fr grid-cols-2 gap-2 sm:grid">
          {thumbs.map((photo, index) => (
            <div
              key={photo}
              className={`relative ${
                // An odd trailing thumbnail stretches full width so the grid never
                // ends with an empty cell.
                index === thumbs.length - 1 && thumbs.length % 2 === 1 ? 'col-span-2' : ''
              }`}
            >
              <Photo
                src={uploadUrl(photo)}
                alt={`${title} — view ${index + 2}`}
                loading="lazy"
                className="h-full w-full rounded-xl object-cover"
              />
              {index === thumbs.length - 1 && extraCount > 0 && (
                <span className="absolute bottom-2 right-2 rounded-full bg-black/70 px-2.5 py-1 text-xs font-bold text-white">
                  +{extraCount} more
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
